<template>
  <MultipleSelector
    localSearch
    data-testid="multipleSiteGroupSelector-multipleSelector-siteGroups"
    :buttonText="$t('multiple_selector.add_site_group')"
    :disabled="disabled"
    :label="$t('common.site_group_other')"
    :options="siteGroupOptions"
    :selectionLimit="maxSiteGroups"
    :type="$t('common.site_group_other')"
    :value="value"
    :zIndex="zIndex"
    @change="$emit('change', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import MultipleSelector from '@/components/MultipleSelector/MultipleSelector.vue'

export default {
  name: 'MultipleSiteGroupSelector',

  components: {
    MultipleSelector,
  },

  props: {
    disabled: Boolean,
    maxSiteGroups: { type: Number, default: 15 },
    options: { type: Array, default: null },
    value: { required: true, type: Array },
    zIndex: Number,
  },

  computed: {
    ...mapGetters(['organizationSiteGroups']),

    siteGroupOptions() {
      const siteGroups = this.options ?? this.organizationSiteGroups

      return siteGroups.map(siteGroup => {
        return {
          ...siteGroup,
          icon: 'mdi-office-building',
          title: siteGroup.name,
        }
      })
    },
  },
}
</script>
